import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASS = "active";
const CREDIT_EXPIRATION_TAB = "credit-expiration-tab";

// The server renders both tables visible; hiding one is this controller's whole job. Personal
// organizations get neither tab nor the expiration table, and must be left exactly as rendered.
export default class extends Controller {
  static get targets() {
    return ["activityTab", "expirationTab", "activityTable", "expirationTable"];
  }

  connect() {
    if (!this.hasExpirationTabTarget) { return; }

    if (new URLSearchParams(window.location.search).get("tab") === CREDIT_EXPIRATION_TAB) {
      this.showExpirationTable();
    } else {
      this.showActivityTable();
    }
  }

  showActivityTable() {
    this.activityTabTarget.classList.add(ACTIVE_CLASS);
    this.expirationTabTarget.classList.remove(ACTIVE_CLASS);

    this.activityTableTarget.style.display = "block";
    this.expirationTableTarget.style.display = "none";
  }

  showExpirationTable() {
    this.activityTabTarget.classList.remove(ACTIVE_CLASS);
    this.expirationTabTarget.classList.add(ACTIVE_CLASS);

    this.activityTableTarget.style.display = "none";
    this.expirationTableTarget.style.display = "block";
  }
}
